import { render } from "./CallToAction.vue?vue&type=template&id=2f6168bc&scoped=true&ts=true"
import script from "./CallToAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallToAction.vue?vue&type=script&setup=true&lang=ts"

import "./CallToAction.vue?vue&type=style&index=0&id=2f6168bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6168bc"],['__file',"src/views/home-view/components/CallToAction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f6168bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f6168bc', __exports__)) {
    api.reload('2f6168bc', __exports__)
  }
  
  module.hot.accept("./CallToAction.vue?vue&type=template&id=2f6168bc&scoped=true&ts=true", () => {
    api.rerender('2f6168bc', render)
  })

}


export default __exports__